<template>
  <div class="container pos-rel" style="background: #000">
    <div class="padding-10">
      <div class="pos-rel">
        <img src="/static/images/bg-bottom.png" style="width: 100%" />
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "download",
  components: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
  
<style scoped>
</style>
  


// WEBPACK FOOTER //
// src/page/homepage/components/md/cooperation.vue